import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './AdSocialPage.css';
const AdSocialPage = ({ page, zoneId="peupleqc_wall"}) => {
  if (typeof page === "undefined")
    return;
    
  const { page_id, page_title, avatar, cover, page_description } = page;
  const [hasLiked, setHasLiked] = useState(false);
  const [impressionTracked, setImpressionTracked] = useState(false);
  const adRef = useRef(null);

  // Fonction pour suivre l'impression de la publicité
  const trackImpression = async () => {
    if (!impressionTracked) {
      console.log("tracking impression");
      setImpressionTracked(true);
      await sdk.models.AdsImpression.addPageImpression({ 
        page_id: page_id,
        zoneId: zoneId
      });
    }
  };

  // Observer pour détecter si l'élément est visible
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          trackImpression(); // Suivre l'impression une fois visible
        }
      },
      { threshold: 0.5 } // Déclenche lorsque 50% de l'élément est visible
    );

    if (adRef.current) {
      observer.observe(adRef.current);
    }

    return () => {
      if (adRef.current) observer.unobserve(adRef.current);
    };
  }, [impressionTracked]);

  // Fonction pour liker la page
  const likePage = async () => {
    setHasLiked(true);
    await sdk.models.PageLike.create({ page_id: page_id });
    await sdk.models.AdsClick.addPageLike({ 
      page_id: page_id,
      zoneId: zoneId
    });
  };  

  return (
    <div ref={adRef} className="ad-social-page border rounded shadow-sm mb-4 p-3">
      <div className="ad-label text-center text-uppercase text-muted mb-2">
        <small>Publicité</small>
      </div>
      <div
        className="cover-image"
        style={{
          backgroundImage: `url(${"https://peupleqc.com/s/peupleqc-upload/" + cover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "150px",
          borderRadius: "8px",
        }}
      ></div>

      <div className="d-flex align-items-center mt-3">
        <img
          src={"https://peupleqc.com/s/peupleqc-upload/" + avatar}
          alt={`Avatar de ${page_title}`}
          className="avatar rounded-circle me-3"
          style={{ width: "60px", height: "60px", objectFit: "cover" }}
        />
        <div>
          <h5 className="mb-1">{page_title}</h5>
          <p className="text-muted small mb-0">{page_description}</p>
        </div>
      </div>

      {!hasLiked && (
        <div className="text-center mt-3">
          <button className="btn btn-primary btn-sm" onClick={likePage}>
            J'aime cette page
          </button>
        </div>
      )}
    </div>
  );
};

export { AdSocialPage };
